import React from 'react';
import QRCode from 'qrcode.react'

export default function MethodQRCode({ url }) {
	return <QRCode value={url} />
}